export default __webpack_public_path__ + "static/media/File_Save.01c4e474.svg";